var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loader"},[_c('img',{attrs:{"src":require("@/assets/Images/loading.svg"),"width":"100"}})])
}]

export { render, staticRenderFns }